<template>
  <div class="carousel-container">
    <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <div v-if="!items || items.length === 0" class="carousel-nodata">
        <img class="empty-img" src="../img/nodata.png" alt="">
        <div class="no-data-title">暂无排查数据</div>
      </div>
      <div v-else class="carousel-item" v-for="(item, index) in items" :key="index">
        <div class="check-message">
          <div class="check-name">{{ item.inspector }}</div>
          <div class="check-description">问题描述：{{ item.issueDescription }}</div>
          <div class="message-bottom">
            <div class="check-time">{{ item.inspectionTime }}</div>
            <div class="check-button">
              <el-button type="text" size="small" @click="editItem(item)">编辑</el-button>
              <el-button type="text" size="small" style="color: #D61E1E" @click="deleteItem(item)">删除</el-button>
            </div>
          </div>
        </div>
        <div v-if="!item.issueUrl || item.issueUrl.length === 0" class="check-img">暂无图片</div>
        <div v-else class="check-img">
          <el-image
            v-for="(url, idx) in item.issueUrl"
            :key="idx"
            :src="url"
            :preview-src-list="item.issueUrl"
            :initial-index="idx"
            style="width: 150px; height: 150px; border-radius: 5px; cursor: pointer;"
            fit="cover"
            :preview-teleported="true"
            hide-on-click-modal></el-image>
        </div>
      </div>
    </div>
    <div class="indicators">
      <button class="nav-button prev" @click="prevPage" :disabled="currentIndex === 0">&#8249;</button>
      <div
        v-for="(item, index) in items"
        :key="index"
        class="indicator"
        :class="{ active: index === currentIndex }"
        @click="goTo(index)"
      ></div>
      <button class="nav-button next" @click="nextPage" :disabled="currentIndex === items.length - 1">&#8250;</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    goTo(index) {
      this.currentIndex = index;
    },
    editItem(item) {
      this.$emit('edit-item', item);
    },
    deleteItem(item) {
      this.$emit('delete-item', item);
    },
    prevPage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    nextPage() {
      if (this.currentIndex < this.items.length - 1) {
        this.currentIndex++;
      }
    }
  },
};
</script>

<style scoped lang="less">
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  min-width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  font-size: 16px;
  padding: 40px;
  border-radius: 5px;
  border: 1px solid rgba(0,0,0,0.12);

  .check-message{
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 20px;
    color: rgba(0,0,0,0.65);
  }

  .message-bottom {
    height: 20%;
    width: 100%;
    min-width: 0;
    display: flex;
    justify-content: space-between;
  }

  .check-name {
    height: 20%;
    width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .check-description {
    height: 60%;
    width: 100%;
    min-width: 0;
    word-wrap: break-word;
    white-space: normal;
    display: flex;
  }

  .check-img {
    flex: 1;
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }

  .check-time {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .check-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}

.carousel-nodata {
  width: 100%;
  min-width: 100%;
  height: 270px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background: url("../img/nodata-bg.png") no-repeat center;
}

.empty-img {
  width: 220px;
  height: 156px;
}

.no-data-title {
  font-size: 16px;
  color: rgba(0,0,0,0.4);
  font-family: OPPOSans-M, sans-serif;
  margin-top: 10px;
}

.indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.nav-button {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  color: #007bff;
  padding: 5px 10px;
  border-radius: 5px;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: rgba(0, 123, 255, 0.1);
  }
}

.indicator {
  width: 10px;
  height: 10px;
  background-color: #ccc;
  border-radius: 5px;
  margin: 5px 10px;
  cursor: pointer;
}

.indicator.active {
  background-color: #007bff;
}
</style>
